require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[52],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-toolkit-select-compat{width:100%}.ba-toolkit-select-compat .bx--select-input{width:100%;min-width:100%}", ""]);

// exports


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(479);


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Select = _interopRequireDefault(__webpack_require__(480));

exports.default = _Select.default;
exports.Select = _Select.default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _baUiCarbon = __webpack_require__(9);

__webpack_require__(481);

var _StringResource = _interopRequireDefault(__webpack_require__(482));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  BaPropTypes
} = _utils.propsUtils;

const DEFAULT_LABEL = _StringResource.default.get('selectOption');

class Select extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {});
    (0, _defineProperty2.default)(this, "toolkitOnChange", e => {
      const {
        onChange,
        options = []
      } = this.props;
      const {
        value
      } = e.target;
      const index = options.findIndex(o => String(o.value) === value);
      const option = options[index];
      onChange && onChange(option.value, option.label, index);
    });
  }

  render() {
    // destructuring unused props so that they can be ignored
    const {
      // removed - remapped

      /* eslint-disable react/prop-types */
      children,
      className,
      disabled,
      hideLabel,
      labelText,
      onChange,
      size,
      value,

      /* eslint-enable react/prop-types */
      // removed - deprecated
      active,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      customWidth = '100%',
      displayLabel,
      grouped,
      hover,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      icon,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      intent,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      label,
      options,
      readOnly,
      selected,
      showAllList,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      textDir,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      truncated,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      variableClassName,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      variant,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // pass all other props to otherCarbonSelectProps
      ...otherCarbonSelectProps
    } = this.props;
    const {
      defaultValue
    } = this.props; // eslint-disable-line react/prop-types
    // remap className

    const mappedClassName = `${className != null ? className : ''} ba-toolkit-select-compat`; // remap disabled

    const mappedDisabled = disabled != null ? disabled : readOnly; // remap labelText

    const mappedLabelText = labelText != null ? labelText : label; // remap hideLabel

    const mappedHideLabel = (hideLabel != null ? hideLabel : mappedLabelText === undefined) ? true : undefined; // remap onChange

    const mappedOnChange = children ? onChange : this.toolkitOnChange; // remap size

    const mappedSize = size === 'small' ? 'sm' : size === 'normal' ? undefined : size; // remap value

    const mappedValue = value != null ? value : selected; // remap children / options

    let mappedChildren = children;

    if (!mappedChildren) {
      if (!grouped) {
        mappedChildren = (options || []).map(({
          label,
          ...otherSelectItemProps
        }) => /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItem, (0, _extends2.default)({
          text: label
        }, otherSelectItemProps)));
      } else {
        // attempts to mimic toolkit grouped behavior in carbon
        mappedChildren = (options || []).reduce((groups, {
          label,
          group,
          ...otherSelectItemProps
        }, i) => {
          const option = /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItem, (0, _extends2.default)({
            text: label
          }, otherSelectItemProps)); // if we don't have a group we push the option directly


          if (group == null) {
            groups.push(option);
          } else if (i === 0 || group !== options[i - 1].group) {
            // if it's our first entry or we've entered a new group
            groups.push(group ? /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItemGroup, {
              label: group
            }, option) : option);
          } else {
            // otherwise we're in the same group, add the option to the children of the previous group
            const element = groups[groups.length - 1];
            groups[groups.length - 1] = _react.default.cloneElement(element, {
              children: [..._react.default.Children.toArray(element.props.children), option]
            });
          }

          return groups;
        }, []);
      }
    } // Adding a DEFAULT_LABEL entry to the mappedChildren if one does not already exist and one is needed.
    // This is non-Carbon.
    // Carbon expects clients to fill out all the children(CarbonSelectItem) nodes.


    if (this.state.defaultSelectItem) {
      // If we've injected a default option, continue to inject it.
      // Changing the number of CarbonSelectItems leads to mismatched IDs -> Items in the select.
      mappedChildren.unshift(this.state.defaultSelectItem);
    } else {
      const defaultOption = defaultValue != null ? defaultValue : mappedValue;

      if (!children && (!defaultOption || (options || []).every(o => o.value !== defaultOption))) {
        /*
         * In order to mimic old functionality, we create a hidden option with
         * content of as the text and bogus '__displayLabel__' as the value.
         * The option is inserted at the beginning of the options.
         * Since the option is hidden, it can never be selected, but visually achieves
         * the trick of a display label (e.g. 'Select an option').  Consumers may need to revisit down the
         * road and support this by supplying their own 'display label' as part of the 'options'.
         */
        const defaultSelectItem = /*#__PURE__*/_react.default.createElement(_baUiCarbon.SelectItem, {
          value: defaultOption != null ? defaultOption : '__displayLabel__',
          text: displayLabel != null ? displayLabel : DEFAULT_LABEL,
          hidden: true
        }); // insert at beginning, if no defaultOption set first entry is always shown


        mappedChildren.unshift(defaultSelectItem); // If we've injected a default option, save it in case it needs to be injected later.
        // Changing the number of CarbonSelectItems leads to mismatched IDs -> Items in the select.

        this.setState({
          defaultSelectItem
        });
      }
    } // Carbon Select does not honor the style={{ width: 'someWidth' }} prop
    // To address this we need to apply width to a few spots within the Carbon Select widget.
    // This is really hokey.
    // Carbon bug: https://github.com/carbon-design-system/carbon/issues/7259
    //
    // <div class="bx-form-item" >
    // 	// need to apply width="100%" to this div to stretch the select to match its parents width (done in the scss file)
    // 	<div class="bx--select ba-toolkit-select-compat">
    // 		<label>
    // 		// need to apply width="customWidth" to this div to make select the size the user wants (done here, apply to parent of bx--select-input)
    // 		<div class="bx--select-input__wrapper" >
    // 			// need to apply width="100%" and min-width="100%" to this select to stretch/shrink the select contents (done in the scss file)
    // 			<select class="bx--select-input"
    // 			<svg


    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Select, (0, _extends2.default)({}, otherCarbonSelectProps, {
      className: mappedClassName,
      disabled: mappedDisabled,
      hideLabel: mappedHideLabel,
      labelText: mappedLabelText,
      onChange: mappedOnChange,
      ref: el => {
        el && el.parentNode.style.setProperty('width', customWidth);
      },
      size: mappedSize,
      value: mappedValue
    }), mappedChildren);
  }

}

exports.default = Select;
(0, _defineProperty2.default)(Select, "propTypes", {
  /** Deprecated (not applicable to Carbon Select): Passed as a prop to Select Button component */
  active: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** deprecated - set style={width: 'in px or %', min-width: 'in px or %'} */
  customWidth: BaPropTypes.deprecated('deprecated - set style={width: "in px or %", min-width: "in px or %"}'),
  disabled: _propTypes.default.bool,

  /** deprecated - no Carbon option */
  displayLabel: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - supply children nested using the Carbon <SelectItemGroup> component */
  grouped: BaPropTypes.deprecated('deprecated - supply children nested using the Carbon <SelectItemGroup> component'),

  /** Deprecated (not applicable to Carbon Select): Passed as a prop to Select Button component */
  hover: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Icon diplayed inside the Select box */
  icon: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Sets the intent for Select box (Passed as a prop to Button component) */
  intent: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated: Label displayed at the top of Select. Use the carbon prop 'labelText' */
  label: BaPropTypes.deprecated(' is deprecated, use the carbon prop labelText'),

  /** deprecated(sort of) - used as Toolkit prop returns a non-standard signature(value,label,index), used as Carbon prop returns standard signature(event). If options are childern = Carbon, else toolkit. */
  onChange: BaPropTypes.deprecated('deprecated(sort of) - used as Toolkit prop returns a non-standard signature(value,label,index), used as Carbon prop returns standard signature(event). If options are childern = Carbon, else toolkit.'),

  /** deprecated - pass menu items as children. As a toolkit prop Items can be grouped using 'group' prop. Note: grouped prop should be set to true to make grouping work */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    group: _propTypes.default.any,
    value: _propTypes.default.any.isRequired,
    label: _propTypes.default.string.isRequired
  })).isRequired,

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),

  /** deprecated - use value; if defining a default option ===IN CARBON THE CLIENT MUST ADD THE DEFAULT(undefined) "Select an option" ENTRY TO ITS CHILDREN=== */
  selected: BaPropTypes.deprecated('deprecated - use value; if defining a default option ===IN CARBON THE CLIENT MUST ADD THE DEFAULT(undefined) "Select an option" ENTRY TO ITS CHILDREN==='),

  /** Deprecated (not applicable to Carbon Select): Display the entire list of items without the scrollbar */
  showAllList: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Text direction */
  textDir: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): If set to true, dropdown items texts will be truncated */
  truncated: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Variable class names */
  variableClassName: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Sets the variant for Select box (Passed as a prop to Button component) */
  variant: BaPropTypes.deprecated(' is ignored and not applicable to carbon select')
});
(0, _defineProperty2.default)(Select, "__Select__", true);

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Select_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(144);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Select_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Select_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Select_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Select_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _utils = __webpack_require__(5);

var _SelectResources = _interopRequireDefault(__webpack_require__(483));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_SelectResources.default);

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

var amdi18n={"__root":{"selectOption":"Select an option"},"__cs":{"selectOption":"Vybrat volbu"},"__da":{"selectOption":"Vælg en indstilling"},"__de":{"selectOption":"Option auswählen"},"__es":{"selectOption":"Seleccionar una opción"},"__fi":{"selectOption":"Valitse jokin vaihtoehto"},"__fr":{"selectOption":"Sélectionner une option"},"__hr":{"selectOption":"Izaberite opciju"},"__hu":{"selectOption":"Válasszon ki egy beállítást"},"__it":{"selectOption":"Seleziona un'opzione"},"__ja":{"selectOption":"オプションの選択"},"__kk":{"selectOption":"Параметрді таңдаңыз"},"__ko":{"selectOption":"옵션 선택"},"__nb":{"selectOption":"Velg et alternativ"},"__nl":{"selectOption":"Selecteer een optie"},"__no":{"selectOption":"Velg et alternativ"},"__pl":{"selectOption":"Wybierz opcję"},"__pt":{"selectOption":"Selecione uma Opção"},"__pt-br":{"selectOption":"Selecione uma Opção"},"__ro":{"selectOption":"Selectaţi o opţiune"},"__ru":{"selectOption":"Выбрать опцию"},"__sl":{"selectOption":"Izbira možnosti"},"__sv":{"selectOption":"Välj ett alternativ"},"__th":{"selectOption":"เลือกอ็อพชัน"},"__tr":{"selectOption":"Bir Seçenek belirleyin"},"__zh":{"selectOption":"选择选项"},"__zh-cn":{"selectOption":"选择选项"},"__zh-hk":{"selectOption":"選取選項"},"__zh-mo":{"selectOption":"選取選項"},"__zh-sg":{"selectOption":"选择选项"},"__zh-tw":{"selectOption":"選取選項"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[478,0]]]);
});